import React from 'react';
import { Link } from 'react-router-dom';
import './Auth.css';

export default function PaypalCancel() {
  return (
    <div className="auth-page">
      <div className="card auth-card">
        <h1>Payment cancelled</h1>
        <p className="auth-subtitle">You cancelled the PayPal checkout. No charge was made.</p>
        <Link to="/dashboard" className="btn btn-primary">Back to Dashboard</Link>
      </div>
    </div>
  );
}
